// extracted by mini-css-extract-plugin
export var completionBody = "_ml-2";
export var completionCard = "_ml-0";
export var completionFooter = "_ml-3";
export var completionTitle = "_ml-1";